export default "__VITE_ASSET__D2ZC1wh9__"